import React from "react"

import { ImageTag, Obj, Widget } from "scrivito"
import { exists } from "shared/lib/exists"
import { Image } from "shared/ui/image/Image"

export const ScrivitoImage = React.memo(
  (
    props: React.ComponentProps<typeof ImageTag> & {
      content: Obj | Widget | null | undefined
      alt: string | null | undefined
      isLoading?: boolean
      className?: string
    }
  ) => {
    const { className, isLoading, alt, ...rest } = props

    return (
      <Image className={className} isLoading={isLoading}>
        <ImageTag {...rest} alt={exists(alt) ? JSON.stringify(alt) : ""} />
      </Image>
    )
  }
)
